import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Spinner, Toast, ToastContainer } from "react-bootstrap";
import InputMask from "react-input-mask";
import { useNavigate } from "react-router-dom";
import packageJson from '../../../../../../package.json';
import { AccountStrings, IFormSignupComponent } from "../../../business/core";
import { FormRecoveryControllerImpl } from "../../../business/impl/controllers";

export const FormRecoveryAccessComponent: React.FC<IFormSignupComponent> = ({ setStep, setData }) => {
    const navigate = useNavigate();
    const [validated, setValidated] = useState(false);
    const [contact, setContact] = useState<string>("");
    const [isPhone, setPhone] = useState<boolean>(false);
    const [contactError, setContactError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [toastingText, setToastingText] = useState<string | null>(null);
    const version = packageJson.version;

    const controller = new FormRecoveryControllerImpl();

    const translate = AccountStrings['PTBR'].recovery;

    const validateContact = () => {
        if (contact.length <= 12) {
            const trimmedContact = contact.trim();
            const digitsOnly = trimmedContact.replace(/\D/g, '');

            const relevantDigits = digitsOnly.startsWith('0') ? digitsOnly.slice(1) : digitsOnly;

            const isValidPhone = (relevantDigits.length >= 9 && relevantDigits.length <= 11 &&
                relevantDigits[2] === '9');
            setPhone(isValidPhone);
        }
    };
    useEffect(() => {
        const digitsOnly = contact.replace(/\D/g, '');
        if (digitsOnly.length !== 11 && isPhone) {
            setContact('');
            setPhone(false);
        }
    }, [contact, isPhone]);

    const handleSubmit = async (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();

        setValidated(true);
        setContactError(false);

        if (!contact || contact === "") {
            setValidated(false);
            setContactError(true);
            setIsLoading(false);
            return false;
        }

        if (contact.length <= 12) {
            const numericContact = contact.replace(/\D/g, "");

            if (numericContact.length !== 11) {
                setValidated(false);
                setContactError(true);
                return;
            }

            if (/^(\d)\1+$/.test(numericContact)) {
                setValidated(false);
                setContactError(true);
                return;
            }

            if (numericContact[2] !== "9") {
                setValidated(false);
                setContactError(true);
                return;
            }
        }
        const submitedFormData = new FormData();
        submitedFormData.append("contact", contact);

        if (!setData) return false;

        if (form.checkValidity() === false) {
        } else {
            setIsLoading(true);
            try {
                const response = await controller.requestRecoveryAccess(submitedFormData);
                if (response === 'RECOVERY_SUCCESS') {
                    setData(submitedFormData);
                    setStep(2)
                    return true;
                }
                response ? setToastingText(translate.errors[response]) : setContactError(true);
            } catch (error) {
                setToastingText(translate.errors[error.message]);
            }
            window.scrollTo(0, 0);
            setIsLoading(false);
        }
    };

    return (
        <>
            <p>{translate.description}</p>
            <Form className="mt-4" onSubmit={handleSubmit} validated={validated}>
                {isPhone === true && contact.length === 11 ?
                    <Form.Group className="mb-3" controlId="formBasicPhone">
                        <InputMask
                            mask={translate.inputMask}
                            value={contact}
                            onChange={(e) => setContact(e.target.value)}
                            onBlur={validateContact}
                        >
                            {(inputProps) => (
                                <Form.Control
                                    {...inputProps}
                                    type="tel"
                                    required
                                    minLength={20}
                                    className={`custom-input ${contactError ? "input-error" : ""}`}
                                    isInvalid={contactError}
                                    autoComplete="off"
                                />
                            )}
                        </InputMask>
                        <Form.Control.Feedback type="invalid">
                            {contactError ? translate.errors.SIGNUP_PHONE_BLOCKED : null}
                        </Form.Control.Feedback>
                    </Form.Group>
                    :
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Control
                            required
                            type={"email"}
                            placeholder={translate.contactInput.placeholder}
                            onChange={(e) => setContact(e.target.value)}
                            className="custom-input"
                            disabled={isLoading}
                            isInvalid={contactError}
                            autoFocus
                            autoComplete="off"
                            value={contact}
                            onBlur={validateContact}
                        />
                        <Form.Control.Feedback type="invalid">
                            {contactError ? translate.errors.SIGNUP_PHONE_BLOCKED : ""}
                        </Form.Control.Feedback>
                    </Form.Group>
                }
                <fieldset disabled={isLoading}>
                    <div className="row">
                        <div className="col">
                            <Button
                                variant="primary"
                                type="button"
                                className="px-4 button-flat"
                                onClick={() => {
                                    navigate('/auth', { state: { reload: true } });
                                }}
                                disabled={isLoading}
                            >
                                {!isLoading ? (
                                    translate.backButton
                                ) : (
                                    <Spinner animation="border" size="sm" role="status">
                                        <span className="visually-hidden">...</span>
                                    </Spinner>
                                )}
                            </Button>
                        </div>
                        <div className="col d-flex flex-row-reverse">
                            <Button
                                variant="primary"
                                type="submit"
                                className="px-4 button-flat"
                                disabled={isLoading}
                            >
                                {!isLoading ? (
                                    translate.recoveryButton
                                ) : (
                                    <Spinner animation="border" size="sm" role="status">
                                        <span className="visually-hidden">...</span>
                                    </Spinner>
                                )}
                            </Button>
                        </div>
                    </div>
                    <Row>
                        <Col className="text-center mt-2"><small style={{ color: '#999999' }}>v{version}</small></Col>
                    </Row>
                </fieldset>
            </Form>
            <ToastContainer position="top-end">
                <Toast
                    bg={"danger"}
                    onClose={() => setToastingText(null)}
                    show={toastingText !== null ? true : false}
                    delay={5000}
                    autohide
                >
                    <Toast.Body className={"text-white"}>
                        {toastingText !== null ? toastingText : null}
                    </Toast.Body>
                </Toast>
            </ToastContainer>
        </>
    );
};
